export const getLoading = state => {
    return state.loading;
};
  
export const getError = state => {
    return state.error;
};

export const getUsuario = state => {
    return state.usuario;
};

export const getNavbar = state => {
    return state.navbar;
};

export const getBottons = state => {
    return state.bottons;
};
